"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var PopperHandler = function (_a) {
    var children = _a.children;
    return (react_1["default"].createElement(react_1["default"].Fragment, null, children));
};
exports["default"] = PopperHandler;
//# sourceMappingURL=popper-handler.js.map